import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import Select from "react-dropdown-select";
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import fetch from 'node-fetch';
import MediaQuery, { useMediaQuery } from 'react-responsive';
import ReactGA from 'react-ga';

import useSelectedRegion from '../../utils/selectedRegionHook';
import styles from './RequestModal.module.css';
import { SEND_BUTTON } from '../../utils/constants';

Modal.setAppElement('#root');

const modalStyles = {
  content : {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    borderRadius: '0px',
    padding: '0px',
    minWidth: '50%',
    maxHeight: 'calc(100vh - 2rem)',
    overflowY: 'auto',

  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  }
};

const modalMobileStyles = {
  content : {
    top: '0',
    left: '0',
    right: 'auto',
    bottom: 'auto',
    border: 'none',
    borderRadius: '0px',
    padding: '0px',
    height: '100vh',
    width: '100vw',
    overflowY: 'auto',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  }
};

const countryOptions = [
  {
    "value": "Afghanistan",
    "label": "Afghanistan"
  },
  {
    "value": "Albania",
    "label": "Albania"
  },
  {
    "value": "Algeria",
    "label": "Algeria"
  },
  {
    "value": "Andorra",
    "label": "Andorra"
  },
  {
    "value": "Angola",
    "label": "Angola"
  },
  {
    "value": "Antigua and Barbuda",
    "label": "Antigua and Barbuda"
  },
  {
    "value": "Argentina",
    "label": "Argentina"
  },
  {
    "value": "Armenia",
    "label": "Armenia"
  },
  {
    "value": "Australia",
    "label": "Australia"
  },
  {
    "value": "Austria",
    "label": "Austria"
  },
  {
    "value": "Azerbaijan",
    "label": "Azerbaijan"
  },
  {
    "value": "Bahamas",
    "label": "Bahamas"
  },
  {
    "value": "Bahrain",
    "label": "Bahrain"
  },
  {
    "value": "Bangladesh",
    "label": "Bangladesh"
  },
  {
    "value": "Barbados",
    "label": "Barbados"
  },
  {
    "value": "Belarus",
    "label": "Belarus"
  },
  {
    "value": "Belgium",
    "label": "Belgium"
  },
  {
    "value": "Belize",
    "label": "Belize"
  },
  {
    "value": "Benin",
    "label": "Benin"
  },
  {
    "value": "Bhutan",
    "label": "Bhutan"
  },
  {
    "value": "Bolivia",
    "label": "Bolivia"
  },
  {
    "value": "Bosnia and Herzegovina",
    "label": "Bosnia and Herzegovina"
  },
  {
    "value": "Botswana",
    "label": "Botswana"
  },
  {
    "value": "Brazil",
    "label": "Brazil"
  },
  {
    "value": "Brunei",
    "label": "Brunei"
  },
  {
    "value": "Bulgaria",
    "label": "Bulgaria"
  },
  {
    "value": "Burkina Faso",
    "label": "Burkina Faso"
  },
  {
    "value": "Burundi",
    "label": "Burundi"
  },
  {
    "value": "Côte d'Ivoire",
    "label": "Côte d'Ivoire"
  },
  {
    "value": "Cabo Verde",
    "label": "Cabo Verde"
  },
  {
    "value": "Cambodia",
    "label": "Cambodia"
  },
  {
    "value": "Cameroon",
    "label": "Cameroon"
  },
  {
    "value": "Canada",
    "label": "Canada"
  },
  {
    "value": "Central African Republic",
    "label": "Central African Republic"
  },
  {
    "value": "Chad",
    "label": "Chad"
  },
  {
    "value": "Chile",
    "label": "Chile"
  },
  {
    "value": "China",
    "label": "China"
  },
  {
    "value": "Colombia",
    "label": "Colombia"
  },
  {
    "value": "Comoros",
    "label": "Comoros"
  },
  {
    "value": "Congo (Congo-Brazzaville)",
    "label": "Congo (Congo-Brazzaville)"
  },
  {
    "value": "Costa Rica",
    "label": "Costa Rica"
  },
  {
    "value": "Croatia",
    "label": "Croatia"
  },
  {
    "value": "Cuba",
    "label": "Cuba"
  },
  {
    "value": "Cyprus",
    "label": "Cyprus"
  },
  {
    "value": "Czechia (Czech Republic)",
    "label": "Czechia (Czech Republic)"
  },
  {
    "value": "Democratic Republic of the Congo",
    "label": "Democratic Republic of the Congo"
  },
  {
    "value": "Denmark",
    "label": "Denmark"
  },
  {
    "value": "Djibouti",
    "label": "Djibouti"
  },
  {
    "value": "Dominica",
    "label": "Dominica"
  },
  {
    "value": "Dominican Republic",
    "label": "Dominican Republic"
  },
  {
    "value": "Ecuador",
    "label": "Ecuador"
  },
  {
    "value": "Egypt",
    "label": "Egypt"
  },
  {
    "value": "El Salvador",
    "label": "El Salvador"
  },
  {
    "value": "Equatorial Guinea",
    "label": "Equatorial Guinea"
  },
  {
    "value": "Eritrea",
    "label": "Eritrea"
  },
  {
    "value": "Estonia",
    "label": "Estonia"
  },
  {
    "value": "Eswatini (fmr. \"Swaziland\")",
    "label": "Eswatini (fmr. \"Swaziland\")"
  },
  {
    "value": "Ethiopia",
    "label": "Ethiopia"
  },
  {
    "value": "Fiji",
    "label": "Fiji"
  },
  {
    "value": "Finland",
    "label": "Finland"
  },
  {
    "value": "France",
    "label": "France"
  },
  {
    "value": "Gabon",
    "label": "Gabon"
  },
  {
    "value": "Gambia",
    "label": "Gambia"
  },
  {
    "value": "Georgia",
    "label": "Georgia"
  },
  {
    "value": "Germany",
    "label": "Germany"
  },
  {
    "value": "Ghana",
    "label": "Ghana"
  },
  {
    "value": "Greece",
    "label": "Greece"
  },
  {
    "value": "Grenada",
    "label": "Grenada"
  },
  {
    "value": "Guatemala",
    "label": "Guatemala"
  },
  {
    "value": "Guinea",
    "label": "Guinea"
  },
  {
    "value": "Guinea-Bissau",
    "label": "Guinea-Bissau"
  },
  {
    "value": "Guyana",
    "label": "Guyana"
  },
  {
    "value": "Haiti",
    "label": "Haiti"
  },
  {
    "value": "Holy See",
    "label": "Holy See"
  },
  {
    "value": "Honduras",
    "label": "Honduras"
  },
  {
    "value": "Hungary",
    "label": "Hungary"
  },
  {
    "value": "Iceland",
    "label": "Iceland"
  },
  {
    "value": "India",
    "label": "India"
  },
  {
    "value": "Indonesia",
    "label": "Indonesia"
  },
  {
    "value": "Iran",
    "label": "Iran"
  },
  {
    "value": "Iraq",
    "label": "Iraq"
  },
  {
    "value": "Ireland",
    "label": "Ireland"
  },
  {
    "value": "Israel",
    "label": "Israel"
  },
  {
    "value": "Italy",
    "label": "Italy"
  },
  {
    "value": "Jamaica",
    "label": "Jamaica"
  },
  {
    "value": "Japan",
    "label": "Japan"
  },
  {
    "value": "Jordan",
    "label": "Jordan"
  },
  {
    "value": "Kazakhstan",
    "label": "Kazakhstan"
  },
  {
    "value": "Kenya",
    "label": "Kenya"
  },
  {
    "value": "Kiribati",
    "label": "Kiribati"
  },
  {
    "value": "Kuwait",
    "label": "Kuwait"
  },
  {
    "value": "Kyrgyzstan",
    "label": "Kyrgyzstan"
  },
  {
    "value": "Laos",
    "label": "Laos"
  },
  {
    "value": "Latvia",
    "label": "Latvia"
  },
  {
    "value": "Lebanon",
    "label": "Lebanon"
  },
  {
    "value": "Lesotho",
    "label": "Lesotho"
  },
  {
    "value": "Liberia",
    "label": "Liberia"
  },
  {
    "value": "Libya",
    "label": "Libya"
  },
  {
    "value": "Liechtenstein",
    "label": "Liechtenstein"
  },
  {
    "value": "Lithuania",
    "label": "Lithuania"
  },
  {
    "value": "Luxembourg",
    "label": "Luxembourg"
  },
  {
    "value": "Madagascar",
    "label": "Madagascar"
  },
  {
    "value": "Malawi",
    "label": "Malawi"
  },
  {
    "value": "Malaysia",
    "label": "Malaysia"
  },
  {
    "value": "Maldives",
    "label": "Maldives"
  },
  {
    "value": "Mali",
    "label": "Mali"
  },
  {
    "value": "Malta",
    "label": "Malta"
  },
  {
    "value": "Marshall Islands",
    "label": "Marshall Islands"
  },
  {
    "value": "Mauritania",
    "label": "Mauritania"
  },
  {
    "value": "Mauritius",
    "label": "Mauritius"
  },
  {
    "value": "Mexico",
    "label": "Mexico"
  },
  {
    "value": "Micronesia",
    "label": "Micronesia"
  },
  {
    "value": "Moldova",
    "label": "Moldova"
  },
  {
    "value": "Monaco",
    "label": "Monaco"
  },
  {
    "value": "Mongolia",
    "label": "Mongolia"
  },
  {
    "value": "Montenegro",
    "label": "Montenegro"
  },
  {
    "value": "Morocco",
    "label": "Morocco"
  },
  {
    "value": "Mozambique",
    "label": "Mozambique"
  },
  {
    "value": "Myanmar (formerly Burma)",
    "label": "Myanmar (formerly Burma)"
  },
  {
    "value": "Namibia",
    "label": "Namibia"
  },
  {
    "value": "Nauru",
    "label": "Nauru"
  },
  {
    "value": "Nepal",
    "label": "Nepal"
  },
  {
    "value": "Netherlands",
    "label": "Netherlands"
  },
  {
    "value": "New Zealand",
    "label": "New Zealand"
  },
  {
    "value": "Nicaragua",
    "label": "Nicaragua"
  },
  {
    "value": "Niger",
    "label": "Niger"
  },
  {
    "value": "Nigeria",
    "label": "Nigeria"
  },
  {
    "value": "North Korea",
    "label": "North Korea"
  },
  {
    "value": "North Macedonia",
    "label": "North Macedonia"
  },
  {
    "value": "Norway",
    "label": "Norway"
  },
  {
    "value": "Oman",
    "label": "Oman"
  },
  {
    "value": "Pakistan",
    "label": "Pakistan"
  },
  {
    "value": "Palau",
    "label": "Palau"
  },
  {
    "value": "Palestine State",
    "label": "Palestine State"
  },
  {
    "value": "Panama",
    "label": "Panama"
  },
  {
    "value": "Papua New Guinea",
    "label": "Papua New Guinea"
  },
  {
    "value": "Paraguay",
    "label": "Paraguay"
  },
  {
    "value": "Peru",
    "label": "Peru"
  },
  {
    "value": "Philippines",
    "label": "Philippines"
  },
  {
    "value": "Poland",
    "label": "Poland"
  },
  {
    "value": "Portugal",
    "label": "Portugal"
  },
  {
    "value": "Qatar",
    "label": "Qatar"
  },
  {
    "value": "Romania",
    "label": "Romania"
  },
  {
    "value": "Russia",
    "label": "Russia"
  },
  {
    "value": "Rwanda",
    "label": "Rwanda"
  },
  {
    "value": "Saint Kitts and Nevis",
    "label": "Saint Kitts and Nevis"
  },
  {
    "value": "Saint Lucia",
    "label": "Saint Lucia"
  },
  {
    "value": "Saint Vincent and the Grenadines",
    "label": "Saint Vincent and the Grenadines"
  },
  {
    "value": "Samoa",
    "label": "Samoa"
  },
  {
    "value": "San Marino",
    "label": "San Marino"
  },
  {
    "value": "Sao Tome and Principe",
    "label": "Sao Tome and Principe"
  },
  {
    "value": "Saudi Arabia",
    "label": "Saudi Arabia"
  },
  {
    "value": "Senegal",
    "label": "Senegal"
  },
  {
    "value": "Serbia",
    "label": "Serbia"
  },
  {
    "value": "Seychelles",
    "label": "Seychelles"
  },
  {
    "value": "Sierra Leone",
    "label": "Sierra Leone"
  },
  {
    "value": "Singapore",
    "label": "Singapore"
  },
  {
    "value": "Slovakia",
    "label": "Slovakia"
  },
  {
    "value": "Slovenia",
    "label": "Slovenia"
  },
  {
    "value": "Solomon Islands",
    "label": "Solomon Islands"
  },
  {
    "value": "Somalia",
    "label": "Somalia"
  },
  {
    "value": "South Africa",
    "label": "South Africa"
  },
  {
    "value": "South Korea",
    "label": "South Korea"
  },
  {
    "value": "South Sudan",
    "label": "South Sudan"
  },
  {
    "value": "Spain",
    "label": "Spain"
  },
  {
    "value": "Sri Lanka",
    "label": "Sri Lanka"
  },
  {
    "value": "Sudan",
    "label": "Sudan"
  },
  {
    "value": "Suriname",
    "label": "Suriname"
  },
  {
    "value": "Sweden",
    "label": "Sweden"
  },
  {
    "value": "Switzerland",
    "label": "Switzerland"
  },
  {
    "value": "Syria",
    "label": "Syria"
  },
  {
    "value": "Tajikistan",
    "label": "Tajikistan"
  },
  {
    "value": "Tanzania",
    "label": "Tanzania"
  },
  {
    "value": "Thailand",
    "label": "Thailand"
  },
  {
    "value": "Timor-Leste",
    "label": "Timor-Leste"
  },
  {
    "value": "Togo",
    "label": "Togo"
  },
  {
    "value": "Tonga",
    "label": "Tonga"
  },
  {
    "value": "Trinidad and Tobago",
    "label": "Trinidad and Tobago"
  },
  {
    "value": "Tunisia",
    "label": "Tunisia"
  },
  {
    "value": "Turkey",
    "label": "Turkey"
  },
  {
    "value": "Turkmenistan",
    "label": "Turkmenistan"
  },
  {
    "value": "Tuvalu",
    "label": "Tuvalu"
  },
  {
    "value": "Uganda",
    "label": "Uganda"
  },
  {
    "value": "Ukraine",
    "label": "Ukraine"
  },
  {
    "value": "United Arab Emirates",
    "label": "United Arab Emirates"
  },
  {
    "value": "United Kingdom",
    "label": "United Kingdom"
  },
  {
    "value": "United States of America",
    "label": "United States of America"
  },
  {
    "value": "Uruguay",
    "label": "Uruguay"
  },
  {
    "value": "Uzbekistan",
    "label": "Uzbekistan"
  },
  {
    "value": "Vanuatu",
    "label": "Vanuatu"
  },
  {
    "value": "Venezuela",
    "label": "Venezuela"
  },
  {
    "value": "Vietnam",
    "label": "Vietnam"
  },
  {
    "value": "Yemen",
    "label": "Yemen"
  },
  {
    "value": "Zambia",
    "label": "Zambia"
  },
  {
    "value": "Zimbabwe",
    "label": "Zimbabwe"
  }
];

const RequestModal = (props) => {
  const {
    onRequestClose,
    selectedBusiness = {},
    selectedCores = {},
    selectedCpu = {},
    selectedPlatform = {},
    selectedStorage = [],
    selectedMemory = [],
    selectedSoftware = [],
  } = props;

  const selectedRegion = useSelectedRegion();
  const history = useHistory();
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)'
  });
  const smallControls = useMediaQuery({
    query: '(max-width: 1224px)'
  });

  const htmlHandlers = {
    privacyAgreement: (str) => <a href="https://www.asbis.com/privacy-policy" target="_blank" rel="noreferrer noopener" key="agreement">{str}</a>,
  };

  let predefinedComments = '';
  if (selectedBusiness.type) {
    predefinedComments += `\nBusiness: ${selectedBusiness.title}`;
  }
  if (selectedPlatform.type) {
    predefinedComments += `\nPlatform: ${selectedPlatform.title}`;
  }
  if (selectedCores.type) {
    predefinedComments += `\nNumber of cores: ${selectedCores.title}`;
  }
  if (selectedCpu.type) {
    predefinedComments += `\nCPU: ${selectedCpu.title}`;
  }
  if (selectedStorage.length > 0) {
    predefinedComments += `\nStorage: ${selectedStorage.map(s => s.title).join(', ')}`;
  }
  if (selectedMemory.length > 0) {
    predefinedComments += `\nMemory: ${selectedMemory.map(s => s.title).join(', ')}`;
  }
  if (selectedSoftware.length > 0) {
    predefinedComments += `\nSoftware: ${selectedSoftware.map(s => s.title).join(', ')}`;
  }

  let selectedCountry = [];
  switch(selectedRegion) {
    case 'BY': 
      selectedCountry = [{ label: 'Belarus', value: 'Belarus' }];
      break;
    case 'HR':
      selectedCountry = [{ label: 'Croatia', value: 'Croatia' }];
      break;
    case 'CY':
      selectedCountry = [{ label: 'Cyprus', value: 'Cyprus' }];
      break;
    case 'CS':
      selectedCountry = [{ label: 'Czechia (Czech Republic)', value: 'Czechia (Czech Republic)' }];
      break;
    case 'HU':
      selectedCountry = [{ label: 'Hungary', value: 'Hungary' }];
      break;
    case 'IL':
      selectedCountry = [{ label: 'Israel', value: 'Israel' }];
      break;
    case 'PL':
      selectedCountry = [{ label: 'Poland', value: 'Poland' }];
      break;
    case 'RO':
      selectedCountry = [{ label: 'Romania', value: 'Romania' }];
      break;
    case 'RU':
      selectedCountry = [{ label: 'Russia', value: 'Russia' }];
      break;
    case 'SK':
      selectedCountry = [{ label: 'Slovakia', value: 'Slovakia' }];
      break;
    default:
      selectedCountry = [];
  };

  const [ email, setEmail ] = useState('');
  const [ firstName, setFirstName ] = useState('');
  const [ lastName, setLastName ] = useState('');
  const [ company, setCompany ] = useState('');
  const [ phoneNumber, setPhoneNumber ] = useState('');
  const [ country, setCountry ] = useState(selectedCountry);
  const [ comments, setComments ] = useState(predefinedComments);
  const [ privacyAgreement, setPrivacyAgreement ] = useState(false);
  const [ subscriptionAgreement, setSubscriptionAgreement ] = useState(true);
  const [ errors, setErrors ] = useState({
    email: false,
    firstName: false,
    lastName: false,
    company: false,
    phoneNumber: false,
    privacyAgreement: false,
  });

  const { formatMessage } = useIntl();

  useEffect(() => {
    if (email) {
      setErrors({...errors, email: false});
    }
    if (firstName) {
      setErrors({...errors, firstName: false});
    }
    if (lastName) {
      setErrors({...errors, lastName: false});
    }
    if (company) {
      setErrors({...errors, company: false});
    }
    if (phoneNumber) {
      setErrors({...errors, phoneNumber: false});
    }
    if (privacyAgreement) {
      setErrors({...errors, privacyAgreement: false});
    }
    if (country.length > 0) {
      setErrors({...errors, country: false});
    }
  // eslint-disable-next-line
  }, [email, firstName, lastName, company, phoneNumber, privacyAgreement, country]);

  const validateAndSendForm = () => {
    const newErrors = {
      email: !email,
      firstName: !firstName,
      lastName: !lastName,
      company: !company,
      phoneNumber: !phoneNumber,
      privacyAgreement: !privacyAgreement,
      country: country.length === 0,
    };

    const hasError = Object.values(newErrors).find(e => e);
    if (hasError) {
      setErrors(newErrors);
      return;
    }
   
    onRequestClose();

    const params = new URLSearchParams({
      firstName,
      lastName,
      emails: [email],
      subscribe: subscriptionAgreement,
      phones: [phoneNumber],
      companyName: company,
      incomingComment: comments,
      referrerUrl: window.location.href,
      countryOther: country[0].value,
    });

    ReactGA.set({ dimension10: SEND_BUTTON });

    fetch(`/epyc-platform/submit-request?${params}`, { method: 'GET' })
      .then(() => history.push('/thanks'));
  };

  return (
    <Modal
      isOpen
      onRequestClose={onRequestClose}
      style={isTabletOrMobileDevice ? modalMobileStyles : modalStyles}
    >
      <div className={styles['modal-wrapper']}>
        <MediaQuery minDeviceWidth={1224}>
          <div className={styles['modal-row']}>
            <h1 className={`${styles['modal-title']} Rubik-40pt`}>
              { formatMessage({id: 'RequestModal.title'}) }
            </h1>
            <button className={styles['modal-close-icon']} onClick={onRequestClose}></button>
          </div>
        </MediaQuery>
        <MediaQuery maxDeviceWidth={1224}>
          <div>
            <div className={styles['menu-collapse']}>
              <button
                onClick={onRequestClose}
                className={styles['menu-collapse-icon']}>&#xf00d;</button>
            </div>
          </div>
          <div className={styles['divider']}></div>
          <div>
            <h1 className={`${styles['modal-title']} Rubik-40pt`}>
              { formatMessage({id: 'RequestModal.title'}) }
            </h1>
          </div>
        </MediaQuery>
        <div className={styles['modal-row']}>
          <div className={`${styles['field']} ${errors.email ? styles['error'] : ''}`}>
            <div className={`${styles['field-label']} Rubik-20pt`}>
              { formatMessage({ id: 'RequestModal.emailLabel' }) }
            </div>
            <div className={styles['field-input_container']}>
              <input
                className={`${styles['field-input']} Rubik-26pt`}
                name="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
              />
              <label htmlFor="email"/>
            </div>
            <div className={styles['error-message']}>
              { formatMessage({ id: 'RequestModal.emailError' }) }
            </div>
          </div>
          <div className={styles['field-gap']}/>
          <div className={`${styles['field']} ${errors.company ? styles['error'] : ''}`}>
            <div className={`${styles['field-label']} Rubik-20pt`}>
              { formatMessage({ id: 'RequestModal.companyLabel' }) }
            </div>
            <div className={styles['field-input_container']}>
              <input
                className={`${styles['field-input']} Rubik-26pt`}
                name="company"
                id="company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                type="text"
                required
              />
              <label htmlFor="company"/>
            </div>
            <div className={styles['error-message']}>
              { formatMessage({ id: 'RequestModal.companyError' }) }
            </div>
          </div>
        </div>
        <div className={styles['modal-row']}>
          <div className={`${styles['field']} ${errors.firstName ? styles['error'] : ''}`}>
            <div className={`${styles['field-label']} Rubik-20pt`}>
              { formatMessage({ id: 'RequestModal.firstNameLabel' }) }
            </div>
            <div className={styles['field-input_container']}>
              <input
                className={`${styles['field-input']} Rubik-26pt`}
                name="firstName"
                id="firstName"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                type="text"
                required
              />
              <label htmlFor="firstName"/>
            </div>
            <div className={styles['error-message']}>
              { formatMessage({ id: 'RequestModal.firstNameError' }) }
            </div>
          </div>
          <div className={styles['field-gap']}/>
          <div className={`${styles['field']} ${errors.lastName ? styles['error'] : ''}`}>
            <div className={`${styles['field-label']} Rubik-20pt`}>
              { formatMessage({ id: 'RequestModal.lastNameLabel' }) }
            </div>
            <div className={styles['field-input_container']}>
              <input
                className={`${styles['field-input']} Rubik-26pt`}
                name="lastName"
                id="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                type="text"
                required
              />
              <label htmlFor="lastName"/>
            </div>
            <div className={styles['error-message']}>
              { formatMessage({ id: 'RequestModal.lastNameError' }) }
            </div>
          </div>
        </div>
        <div className={styles['modal-row']}>
          <div className={`${styles['field']} ${errors.phoneNumber ? styles['error'] : ''}`}>
            <div className={`${styles['field-label']} Rubik-20pt`}>
              { formatMessage({ id: 'RequestModal.phoneNumberLabel' }) }
            </div>
            <div className={styles['field-input_container']}>
              <input
                className={`${styles['field-input']} Rubik-26pt`}
                name="phone"
                id="phone"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                type="tel"
                required
              />
              <label htmlFor="phone"/>
            </div>
            <div className={styles['error-message']}>
              { formatMessage({ id: 'RequestModal.phoneError' }) }
            </div>
          </div>
          <div className={styles['field-gap']}/>
          <div className={`${styles['field']} ${errors.country ? styles['error'] : ''}`}>
            <div className={`${styles['field-label']} Rubik-20pt`}>
              { formatMessage({ id: 'RequestModal.countryLabel' }) }
            </div>
            <div className={styles['field-select_container']}>
              <Select
                options={countryOptions}
                values={country}
                labelField="label"
                valueField="value"
                onChange={(e) => { setCountry(e)}}
                placeholder={ formatMessage({ id: 'RequestModal.countryPlaceholder' }) }
                searchable={false}
                style={{
                  width: '100%',
                  padding: '15px 25px 13px',
                  border: 'none',
                  borderBottom: 'solid 1px rgba(0, 0, 0, 0.2)',
                  fontSize: smallControls ? '20px' : '26px',
                  fontFamily: 'Rubik',
                  backgroundColor: '#e7e7e7',
                }}
              />
            </div>
            <div className={styles['error-message']}>
              { formatMessage({ id: 'RequestModal.countryError' }) }
            </div>
          </div>
        </div>
        <div className={styles['modal-row']}>
          <div className={styles['field']}>
            <div className={`${styles['field-label']} Rubik-20pt`}>
              { formatMessage({ id: 'RequestModal.commentsLabel' }) }
            </div>
            <div className={styles['field-input_container']}>
              <textarea
                className={`${styles['field-input']} Rubik-26pt`}
                name="comments"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className={styles['modal-row']}>
          <div className={`${styles['field_checkbox']} ${errors.privacyAgreement ? styles['error'] : ''}`}>
            <div className={styles['checkbox']}>
              <input
                type="checkbox"
                className={styles['checkbox-field']}
                name="privacy-agreement"
                id="privacy-agreement"
                checked={privacyAgreement}
                onChange={(e) => setPrivacyAgreement(e.target.checked)}
              />
              <label htmlFor="privacy-agreement"></label> 
            </div>
            <div className={`${styles['field-label']} Rubik-20pt`}>
              { formatMessage({ id: 'RequestModal.privacyAgreement' }, htmlHandlers) }
              <div className={styles['error-message']}>
                { formatMessage({ id: 'RequestModal.privacyAgreementError' }) }
              </div>
            </div>
          </div>
        </div>
        <div className={styles['modal-row']}>
          <div className={styles['field_checkbox']}>
            <div className={styles['checkbox']}>
              <input
                type="checkbox"
                className={styles['checkbox-field']}
                name="subscription-agreement"
                id="subscription-agreement"
                checked={subscriptionAgreement}
                onChange={(e) => setSubscriptionAgreement(e.target.checked)}
              />
              <label htmlFor="subscription-agreement"></label> 
            </div>
            <div className={`${styles['field-label']} Rubik-20pt`}>
              { formatMessage({ id: 'RequestModal.subscriptionAgreement' }) }
            </div>
          </div>
        </div>
        <div className={styles['modal-row']}>
          <button className={`${styles['send-button']} Rubik-20pt`} onClick={validateAndSendForm}>
            { formatMessage({ id: 'RequestModal.sendButton' }) }
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RequestModal;
